export enum ActivityType {
  Unspecified = 0,
  Consumption = 1,
  Labelling = 2,
}
